import styles from "./style.module.scss";
import TopImage from "src/assets/activity_top_image.jpg";

export const TopSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.backgroundImg}>
        <img src={TopImage} alt="Activity" />
        <div className={styles.titleBox}>
          <h1>Activity</h1>
          <p>体験一覧</p>
        </div>
      </div>
    </section>
  );
};
